import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTINVENTORY,
  DELETE_PRODUCTINVENTORY,
  UPDATE_PRODUCTINVENTORY,
  ADD_NEW_PRODUCTINVENTORY,
} from "./actionType";

import {
  getProductInventorySuccess,
  getProductInventoryFail,
  deleteProductInventorySuccess,
  deleteProductInventoryFail,
  updateProductInventorySuccess,
  updateProductInventoryFail,
  addProductInventorySuccess,
  addProductInventoryFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveProductInventoryApi,
  getProductInventoryApi,
  updateProductInventoryApi,
  deleteProductInventoryApi,
  addNewProductInventoryApi
} from "../../helpers/backend_helper";

function* getProductInventory({ payload: productInventory }) {
  try {
    const response = yield call(getProductInventoryApi, productInventory);
    yield put(getProductInventorySuccess(GET_PRODUCTINVENTORY, response.data));
  } catch (error) {
    yield put(getProductInventoryFail(GET_PRODUCTINVENTORY, error));
  }
}

function* onUpdateProductInventory({ payload: productInventory }) {
  try {
    if (productInventory.setApprove) {
      const response = yield call(approveProductInventoryApi, productInventory);
      yield put(updateProductInventorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateProductInventoryApi, productInventory);
      yield put(updateProductInventorySuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateProductInventoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductInventory({ payload: productInventory }) {
  try {
    const response = yield call(deleteProductInventoryApi, productInventory);
    yield put(deleteProductInventorySuccess({ productInventory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductInventoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductInventory({ payload: productInventory }) {
  try {
    const response = yield call(addNewProductInventoryApi, productInventory);
    yield put(addProductInventorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductInventoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductInventory() {
  yield takeEvery(GET_PRODUCTINVENTORY, getProductInventory);
}

export function* watchUpdateProductInventory() {
  yield takeEvery(UPDATE_PRODUCTINVENTORY, onUpdateProductInventory);
}

export function* watchDeleteProductInventory() {
  yield takeEvery(DELETE_PRODUCTINVENTORY, onDeleteProductInventory);
}

export function* watchAddNewProductInventory() {
  yield takeEvery(ADD_NEW_PRODUCTINVENTORY, onAddNewProductInventory);
}

function* productInventorySaga() {
  yield all([
    fork(watchGetProductInventory),
    fork(watchDeleteProductInventory),
    fork(watchUpdateProductInventory),
    fork(watchAddNewProductInventory)
  ]);
}

export default productInventorySaga;
